"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const uris_1 = require("../globals/uris");
const autocontrol_1 = require("./autocontrol");
const fetcher_1 = require("../util/fetcher");
/**
 * Data controls that fetch data online to set their values.
 */
class DataControl extends autocontrol_1.AutoControl {
    constructor(uri, url, jsonMap, store, fetcher = new fetcher_1.FetchFetcher()) {
        super(uri, uris_1.DATA_CONTROL, store);
        this.fetcher = fetcher;
        this.frequency = 60000;
        this.url = url;
        this.jsonMap = jsonMap;
        this.store.setControlParam(this.uri, uris_1.AUTO_CONTROL_TRIGGER, 1);
    }
    update() {
        this.fetcher.fetchJson(this.url)
            .then(json => this.jsonMap(json))
            .then(mapped => {
            console.log("data received:", mapped);
            this.updateValue(mapped);
        })
            .catch(e => console.log(e));
    }
}
exports.DataControl = DataControl;



//////////////////
// WEBPACK FOOTER
// ./~/dymo-core/lib/controls/datacontrol.js
// module id = 1294
// module chunks = 3